// extracted by mini-css-extract-plugin
export var ContentContainer = "internships-module--ContentContainer--dFVBz";
export var Img = "internships-module--Img--Z94Oz";
export var MainContainer = "internships-module--MainContainer--YNNlJ";
export var cardContainer = "internships-module--cardContainer--jWFlB";
export var cardImg = "internships-module--cardImg--7yi2w";
export var cardInfo = "internships-module--cardInfo--vdt0+";
export var container = "internships-module--container--QlNPA";
export var headText = "internships-module--headText--xQO1o";
export var header = "internships-module--header--3nv67";
export var info = "internships-module--info--rzzzc";
export var link = "internships-module--link--UY2ap";